export default "__VITE_ASSET__c20595e3__"